import VueKonva from 'vue-konva'

export default function (app) {
  app.use(VueKonva, { prefix: 'Konva' })
}
